const parse = (str) => {
    const rules = {};
    const ruleStrings = str.split('|');
    for (let i = 0; i < ruleStrings.length; i++) {
        const ruleString = ruleStrings[i];
        let parts = ruleString.split(':');
        rules[parts[0]] = parts[1] || true;
    }
    return rules;
}

export default parse;